import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import * as Preact from 'preact';
import * as ColourSelector from './A_ColourSelector';
import { useTranslations } from './utils/TranslationsWrapper';
export var Component = function (p) {
    var _a;
    var t = useTranslations().t;
    return (Preact.h(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '87px',
        } },
        Preact.h(Typography, { variant: 'body2', sx: {
                padding: '4px 12px 0px 12px',
            } }, "".concat(t('furniture.headers.color-selector')).concat((_a = p.colours.options.find(function (o) { return o.status === 'active'; })) === null || _a === void 0 ? void 0 : _a.displayName)),
        Preact.h(Box, { display: "flex", flexWrap: "wrap", gap: "6px", sx: {
                width: 'fit-content',
                padding: '12px',
            } }, p.colours.options.map(function (colour) {
            return (Preact.h(ColourSelector.Component, { colour: colour, active: colour.status === 'active', incompatible: colour.status === 'disabled' || colour.compatible === false, onClick: p.onClick }));
        }))));
};
Component.displayName = 'ColourOptionGrid';
